
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Card,
  Form,
  Statistic,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  Button,
  Modal,
  Tooltip,
  List,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../../services/definedMethod";
import definedApi from "../../../../services/definedApi";
import cnt from "../../../../services/definedConstant";
import CustomButton from "../../../../components/custom/CustomButton";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import dayjs from "dayjs";
import { accountStatus } from "../../../../components/facilities/AccountFacility";
import styles from "../../../../assets/styles/styles";

const ChargesForm = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    chargesOptions,
    penaltyOptions,
    userData,
    isLoading,
    setIsLoading,
    chargeTableSource,
    setChargeTableSource,
    penaltyTableSource,
setPenaltyTableSource
  } = props;
  const { session } = userData;
  // const [useForm] = Form.useForm();
  const { Text, Title } = Typography;

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargeList, setChargeList] = useState([]);
  // const [isModalOpen, setIsModalOpen] = useState(false);

  const handleChargeDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = chargeTableSource.filter((item) => item.id !== key.id);
        setChargeTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handlePenaltyDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = penaltyTableSource.filter((item) => item.id !== key.id);
        setPenaltyTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Collected On",
      dataIndex: "collectedOn",
    },
    {
      title: "Date",
      dataIndex: "feeOnMonthDay",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        chargeTableSource.length >= 1 ? (
          <Tooltip title={`Remove Charge`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleChargeDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const penaltyColumns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Collected On",
      dataIndex: "collectedOn",
    },
    {
      title: "Date",
      dataIndex: "feeOnMonthDay",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
      penaltyTableSource.length >= 1 ? (
          <Tooltip title={`Remove Penalty`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handlePenaltyDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          Charge Information
        </Title>
      </Divider>
      <ChargeModal
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        chargeData={chargesOptions}
        setChargeTableSource={setChargeTableSource}
        chargeTableSource={chargeTableSource}
        session={session}
      />

      {chargeTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {chargeTableSource.length > 1
                ? "Selected Charges"
                : "Selected Charge"}
            </Title>
          </Divider>
          <Table
            columns={columns}
            dataSource={chargeTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}    


<Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          Overdue Charge Information
        </Title>
      </Divider>
      <OverdueChargeModal
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        penaltyOptions={penaltyOptions}
        setPenaltyTableSource={setPenaltyTableSource}
        penaltyTableSource={penaltyTableSource}
        session={session}
      />

      {penaltyTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {penaltyTableSource.length > 1
                ? "Selected Penalties"
                : "Selected Penalty"}
            </Title>
          </Divider>
          <Table
            columns={penaltyColumns}
            dataSource={penaltyTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}    
    </Form>
  );
};
export default ChargesForm;

const ChargeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setChargeTableSource,
    chargeTableSource,
    chargeData,
  } = props;

  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [chargeTableCount, setChargeTableCount] = useState(0);

  const handleSelectedCharge = (chargeId) => {
    console.log(chargeId);
    setSelectedCharge(chargeId);
  };
  
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = () => {
    const body = {
      session,
    };
    // return;
    console.log(chargeTableSource)

    const url = `${definedApi.Charges}/${selectedCharge}?template=true`

    setIsLoading(true);

    BOM.FetchReqAction(
      body, url, (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        } else {
          const objList = res;

          const handleAdd = () => {
            const newData = {
              key: chargeTableCount,
              id: objList?.id ? objList?.id : "-",
              name: objList?.name ? objList?.name : "-",
              type: objList?.chargeCalculationType?.value
                ? objList?.chargeCalculationType?.value
                : "-",
              amount: objList?.amount ? (
                <Statistic
                  value={objList?.amount}
                  precision={2}
                  valueStyle={{ fontSize: "16px" }}
                />
              ) : (
                0
              ),
              amountToUse: objList?.amount ? objList?.amount : 0,
              collectedOn: objList?.chargeTimeType?.value
                ? objList?.chargeTimeType?.value
                : "-",
            };
            setChargeTableSource([...chargeTableSource, newData]);

            setChargeTableCount(chargeTableCount + 1);
          };

          handleAdd();

          useForm.resetFields();

          // STOP LOAD
          setIsLoading(false);
          // console.log(chargeTableSource);
        }
      }
    );
  };

  return (
    <Row>
      <Button
        shape="round"
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        Add Charge
      </Button>

      <Modal
        title="Charge Information Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"chargeId"}
                label={"Charge Options"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Charge"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Charge",
                    "select"
                  )}
                  options={chargeData}
                  onChange={handleSelectedCharge}
                  style={{ width: "30vh" }}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const OverdueChargeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    penaltyOptions,
    penaltyTableSource,
setPenaltyTableSource
  } = props;

  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [chargeTableCount, setChargeTableCount] = useState(0);

  // console.log(penaltyOptions)

  const handleSelectedCharge = (chargeId) => {
    console.log(chargeId);
    setSelectedCharge(chargeId);
  };
  
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = () => {
    const body = {
      session,
    };
    // return;

    const url = `${definedApi.Charges}/${selectedCharge}?template=true`

    setIsLoading(true);

    BOM.FetchReqAction(
      body, url, (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        } else {
          const objList = res;

          const handleAdd = () => {
            const newData = {
              key: chargeTableCount,
              id: objList?.id ? objList?.id : "-",
              name: objList?.name ? objList?.name : "-",
              type: objList?.chargeCalculationType?.value
                ? objList?.chargeCalculationType?.value
                : "-",
              amount: objList?.amount ? (
                <Statistic
                  value={objList?.amount}
                  precision={2}
                  valueStyle={{ fontSize: "16px" }}
                />
              ) : (
                0
              ),
              amountToUse: objList?.amount ? objList?.amount : 0,
              collectedOn: objList?.chargeTimeType?.value
                ? objList?.chargeTimeType?.value
                : "-",
            };
            setPenaltyTableSource([...penaltyTableSource, newData]);

            setChargeTableCount(chargeTableCount + 1);
          };

          handleAdd();

          useForm.resetFields();

          // STOP LOAD
          setIsLoading(false);
          // console.log(chargeTableSource);
        }
      }
    );
  };

  return (
    <Row>
      <Button
        shape="round"
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        Add Penalty
      </Button>

      <Modal
        title="Overdue Charge Information Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"penaltyId"}
                label={"Penalty Options"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Overdue Charge"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Penalty",
                    "select"
                  )}
                  options={penaltyOptions}
                  onChange={handleSelectedCharge}
                  style={{ width: "30vh" }}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};



